<template lang="pug">
    .actionmenu-area.d-flex.align-center
        template(v-if="mixToggleMDBreakpoint" v-for="(item, idx) in menuItems")
            //v-btn(v-if="idx != 3" :color="menuBtnColor(item)" :flat="$menuBtnFlat(icon)" :disabled="item.disabled" :key="idx" @click="$router.replace({path: item.route})").font-weight-bold
            v-btn(v-if="idx != 3" :color="menuBtnColor(item)" :flat="menuBtnFlat(item)" :disabled="item.disabled" :key="idx" @click="$router.replace({path: item.route})").font-weight-bold  
                span.mr-1 ({{item.shortcut}})
                span {{item.entry}}
            v-menu(v-else offset-y open-on-hover)
                v-btn(flat slot="activator" :disabled="item.disabled" :key="idx").font-weight-bold
                    span.mr-1 ({{item.shortcut}})
                    span {{item.entry}}
                v-list(v-if="!item.disabled")
                    template(v-for="(dc, idx) in availableDiscounts")
                        v-list-tile
                            v-btn(large block @click="handleClientDiscount(dc)") {{dc}}%
        template(v-else)
            v-menu(offset-y)
                v-btn(flat slot="activator")
                    v-icon menu
                v-list
                    v-list-tile(v-for="(item, idx) in menuItems" :key="idx")
                        v-btn.font-weight-bold(:disabled="item.disabled" block flat @click="$router.replace({path: item.route})")
                            span {{item.entry}}
</template>

<script>
import menu from './menu.js'
import ResponsiveUtils from '@/mixins/ResponsiveUtils'
import { deepClone } from '@/services/ObjectFormatter'
import { mapGetters, mapState, mapActions } from 'vuex'
/**
 * Menu component for accessing the diferent subviews routes
 */
export default {
    name: 'actions-menu',
    props: {},
    data: function() {
        return {
            /**
             * @description
             * Returns items for the menu loaded from ./menu.js
             * Items entry follow this format:
             * @example
             *  {
             *      entry: 'Promos',
             *      shortcut: 'F4',
             *      route: 'promos'
             *  }
             */
            menuItems: menu,
        }
    },
    computed: {
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
        ...mapGetters('AuthModule', {
            isCallCenter: 'isCallCenter',
        }),
        ...mapState('CustomerModule', {
            availableDiscounts: 'availableDiscounts',
        }),
    },
    methods: {
        menuBtnColor(item) {
            // return this.colors.secondary
            let slash = ''
            if (item.route != '/') {
                slash = '/'
            }
            return this.$route.path != `${slash}${item.route}`
                ? null
                : this.colors.secondary
            //return this.$route.path != item.route ? null : this.colors.secondary
        },

        menuBtnFlat(item) {
            let slash = ''
            if (item.route != '/') {
                slash = '/'
            }
            return this.$route.path != `${slash}${item.route}`
        },

        disableForTicket: function(activeTransaction) {
            // Remove this loop to enable remaining menu entries
            // this.menuItems.forEach((item, idx) => {
            //     if (idx > 3) item.disabled = true
            // })
            if (activeTransaction.name == 'ticket') {
                this.menuItems[1].disabled = true
                this.menuItems = deepClone(this.menuItems)
                return
            }
            this.menuItems[1].disabled = false
        },
        ...mapActions('CustomerModule', {
            setClientDiscount: 'setClientDiscount',
        }),
        ...mapActions('CartModule', {
            setGlobalDiscount: 'setGlobalDiscount',
        }),
        handleClientDiscount(discount) {
            this.setClientDiscount(discount)
            this.setGlobalDiscount({
                percentage_discount: discount,
                amount_discount: null,
            })
        },
    },
    watch: {
        /**
         * @description
         */
        activeTransaction: function(newVal, oldVal) {
            if (newVal.id == 6) {
                this.menuItems[0] = {
                    entry: 'Cambio',
                    shortcut: 'F1',
                    route: '/cambio',
                }
            } else {
                this.menuItems[0] = {
                    entry: 'Venta',
                    shortcut: 'F1',
                    route: '/',
                }
            }
            if (
                (newVal.id == 2 || newVal.id == 3) &&
                this.availableDiscounts.length > 0
            ) {
                this.menuItems[3].disabled = false
                this.menuItems = deepClone(this.menuItems)
            } else {
                this.menuItems[3].disabled = true
                this.menuItems = deepClone(this.menuItems)
            }
            if (newVal.id > 3 && newVal.id < 6) {
                this.menuItems[1] = {
                    entry: 'Empleado',
                    shortcut: 'F4',
                    route: '/employee',
                }
                this.menuItems = deepClone(this.menuItems)
            } else {
                this.menuItems[1] = {
                    entry: 'Cliente',
                    shortcut: 'F4',
                    route: 'cliente',
                }
                this.menuItems = deepClone(this.menuItems)
                this.disableForTicket(newVal)
            }
        },
        availableDiscounts: function(newVal, oldval) {
            if (
                (this.activeTransaction.id == 2 ||
                    this.activeTransaction.id == 3) &&
                newVal > 0
            ) {
                this.menuItems[3].disabled = false
                this.menuItems = deepClone(this.menuItems)
            } else {
                this.menuItems[3].disabled = true
                this.menuItems = deepClone(this.menuItems)
            }
        },
        isCallCenter: {
            handler(v) {
                this.menuItems[2] = v
                    ? {
                          entry: 'Sol. Despacho',
                          shortcut: 'F5',
                          route: 'solicitudes_despacho',
                      }
                    : {
                          entry: 'Promos',
                          shortcut: 'F5',
                          route: 'promos',
                      }
            },
            immediate: true,
        },
    },
    components: {},
    mixins: [ResponsiveUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        this.disableForTicket(this.activeTransaction)
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.actionmenu-area {
    width: 100%;
}
@media screen and (max-width: 959px) {
    .actionmenu-area {
        justify-content: center;
        margin-right: -2%;
    }
}
</style>
